<template>
  <div class="entry-header">
    <div class="gradation"></div>
    <div class="header-top">
      <div>
        <v-btn icon depressed dark @click="clickBack">
          <v-icon dark>mdi-arrow-left</v-icon>
        </v-btn>
      </div>
    </div>
    <div class="page-title">
      <h1>Sign Up</h1>
      <img src="@/assets/images/common/signup_title.png" />
      <div class="sub-title mt-4">
        <!-- <p>바이엘 크롭사이언스와 쉽고 편한 농사 함께해요</p> -->
      </div>
    </div>

    <div class="header-bottom">
      <div class="mr-2">
        <img
          class="logo"
          src="@/assets/images/common/bayer_logo_white.png"
          alt="app_logo"
        />
      </div>
      <div>
        <img
          class="title"
          src="@/assets/images/common/pharm_partner_logo_white.png"
          alt="pharm_patner_title_white"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    clickBack() {
      this.$emit("clickBack");
    },
  },
};
</script>
<style lang="">
</style>